<template>
  <div id="page-not-found" class="page-not-found">
    <h2 class="page-heading">404 Page Not Found</h2>
    <p class="url">{{ url }}</p>
  </div>
</template>

<script>
export default {
  name: 'page-not-found',
  title: '404 Not Found',
  data() {
    return {};
  },
  methods: {},
  computed: {
    url: function() {
      return window.location.href;
    },
  },
};
</script>

<style lang="scss" scoped>
.page-not-found {
  padding-top: 9rem;
}

.url {
  font-size: 1.4rem;
  max-width: none;
  text-align: center;
}
</style>
